<div class="modal-header">
  <h4 class="modal-title pull-left">Confirm Next Stage</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <b>Are you sure you want to proceed to the next Stage?</b>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="onConfirm()">Yes</button>
</div>
